import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("i", {
    class: "flaticon-eye position-relative top-2 fs-18 clickable",
    "data-bs-toggle": "modal",
    "data-bs-target": ".contentModalScrollable",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('company-selected', _ctx.company)))
  }))
}